// Dual currency formatting utility
const USD_TO_INR = 83.5;

export const fmtINR = (a) => `₹${(a || 0).toLocaleString('en-IN')}`;
export const fmtUSD = (a) => `$${(a || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

// INR amount -> show as INR / USD
export const dualFromINR = (inr) => `${fmtINR(inr)} / ${fmtUSD(Math.round((inr || 0) / USD_TO_INR))}`;
// USD amount -> show as USD / INR
export const dualFromUSD = (usd) => `${fmtUSD(usd)} / ${fmtINR(Math.round((usd || 0) * USD_TO_INR))}`;

export { USD_TO_INR };
